import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AccountForm from "./accountComponents/AccountForm";

import { useAddAccountMutation } from "store/services/accountApi";

import { useAppMeta } from "hooks";

const AccountCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Accounts", path: "/app/crm/account/list" },
    { title: "New Account" },
  ];

  // RTK Query
  const [createAccount, { isLoading: creatingAccount }] =
    useAddAccountMutation();

  // methods
  const handleCreateAccount = async (data) => {
    try {
      const { _id } = await createAccount(data).unwrap();
      toast.success("Account successfully created!");
      navigate(`/app/crm/account/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Account!"
      );
    }
  };

  useAppMeta("New Account");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingAccount}>
      <BreadcrumbLayout.Paper>
        <AccountForm isBusy={creatingAccount} onSubmit={handleCreateAccount} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AccountCreateScreen;
